import React from 'react';
import { Link } from 'react-router-dom';

import { Direction } from '@prisjakt/ui';
import { ButtonIcon, ButtonSize } from '@prisjakt/ui/button';
import { IconCompare } from '@prisjakt/ui/icon/compare';
import { useAppContext } from 'src/components/app-context';
import { useProductContext } from 'src/areas/product/components/product-context';

import {
  StyledButtonText,
  StyledTooltip,
  StyledButton,
} from '../shared-styles';

export const CompareButton = () => {
  const { t, linkTo } = useAppContext();
  const { product } = useProductContext();
  const linkProps = {
    to: linkTo('productCompare', {
      category: product.category,
      products: [product],
    }),
    rel: 'nofollow',
  };
  return (
    <StyledTooltip
      title={t('product', 'action-button.compare-tooltip')}
      placement={Direction.Down}
    >
      <StyledButton
        ariaLabel={t('product', 'product-compare.compare')}
        container={Link}
        containerProps={linkProps}
        size={ButtonSize.SMALL}
      >
        <ButtonIcon>
          <IconCompare />
        </ButtonIcon>
        <StyledButtonText>
          {t('product', 'product-compare.compare')}
        </StyledButtonText>
      </StyledButton>
    </StyledTooltip>
  );
};
